import { render, staticRenderFns } from "./grid-percentage.vue?vue&type=template&id=9f0e210e&"
import script from "./grid-percentage.ts?vue&type=script&lang=js&"
export * from "./grid-percentage.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports